// Extracted so that we can spy on it in tests
export const createWorkerInstance = source => {
  return new Worker(URL.createObjectURL(new Blob([source], {
    type: 'text/javascript'
  })));
};